<template>
  <div>
    <Modal v-model="inspectModal" width="1000">
      <json-view :data="data" :deep="1" class="container-inspect-json"></json-view>
      <div slot="footer">
        <Button @click="inspectModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getContainerInspect } from '@/api/container/container'
import jsonView from 'vue-json-views'

export default {
  name: 'inspect',
  components: {
    jsonView
  },
  data () {
    return {
      inspectModal: false,
      data: {},
      nodeId: '',
      containerId: '',
      error: false
    }
  },
  methods: {
    showModal (containerId, nodeId) {
      this.nodeId = nodeId
      this.containerId = containerId
      getContainerInspect(this.containerId, {node: this.nodeId}).then(res => {
        this.data = res.data
        this.inspectModal = true
        this.error = false
      }).catch(res => {
        this.error = true
        console.log(res.response)
      })
    }
  }
}
</script>

<style scoped>
  .container-inspect-json {
    padding: 0;
    overflow-y: auto;
    max-height: 600px;
    padding-bottom: 5px;
    margin-right: 20px;
  }
  .container-inspect-json::-webkit-scrollbar {
    width: 5px;
  }
  .container-inspect-json::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .container-inspect-json::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
